import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { API_URL, DOMINIO_ADMIN } from "../consts";
import { useQuery } from "react-query";
import { Clubs } from "../prismaTypes";
import axios, { AxiosError } from "axios";
import { uiStore } from "../uiStore";
import { Button } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { oraPrenotaStore } from "../oraPrenotaStore";
import { queryClient } from "../App";
import { memo } from "react";

export const TopAppBar = memo(function TopAppBar(props: { openBtn: JSX.Element }) {
  const { openBtn } = props;
  const navigate = useNavigate();
  const setToken = oraPrenotaStore((state) => state.setToken);

  const isAdmin = window.location.host.split(".")[0] === DOMINIO_ADMIN;

  const enabled =
    window.location.host.split(".").length > 2 &&
    window.location.host.split(".")[0] !== DOMINIO_ADMIN;
  const { data: club } = useQuery<{ club: Clubs }, AxiosError>(
    ["club/getByDomain"],
    () => axios.get(API_URL + "club/getByDomain").then((res) => res.data),
    {
      enabled,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  const isAuthenticated = oraPrenotaStore((state) => state.isAuthenticated());

  const title = uiStore((state) => state.title);
  const logOut = () => {
    localStorage.clear();
    setToken("");
    queryClient.invalidateQueries();
    localStorage.clear();
    navigate("/logout");
    // window.location.href = window.location.origin + "/login";
  };

  return (
    <Box sx={{ flexGrow: 1, top: 0, position: "sticky", zIndex: 99 }}>
      <AppBar position="static">
        <Toolbar>
          {openBtn}
          {/* <UserInfo /> */}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {club?.club !== null && club?.club?.nome}
            {isAdmin && "Admin "} {" - "} {title}
          </Typography>

          {isAuthenticated && (
            <Button
              onClick={() => logOut()}
              variant="outlined"
              color="inherit"
              size="small"
              startIcon={<LogoutIcon />}
            >
              Logout
            </Button>
          )}

          {/* <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
            <AccountCircleIcon />
          </IconButton> */}
        </Toolbar>
      </AppBar>
    </Box>
  );
});
